<template>
  <el-dialog title="" :visible.sync="showDalog" width="40%" @close="closeDialog" :close-on-click-modal="false">
    <div style="display: flex; height: 100%; margin-top: -1.2vw">
      <div style="
          position: absolute;
          top: 1vw;
          left: 3vw;
          font-size: 1.2rem;
          background: linear-gradient(180deg, rgba(79, 54, 222, 1), rgba(48, 47, 48, 1)); -webkit-background-clip: text;-webkit-text-fill-color: transparent;  font-weight: 400;">
        欢迎使用 全球能
        <img style="position: relative; left: 0.1vw; top: -0.5vw; width: 0.5vw" src="@/assets/r-ico.png" />
      </div>
      <div style="
          height: 100%;
          width: 50%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        ">
        <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 1vw;
          ">
          <div style="width: 8vw; height: 8vw">
            <img src="@/assets/logo_right.png" alt="" style="width: 100%; height: 100%" />
          </div>

          <div style="width: 100%" v-if="loginstatus">
            <div>
              <el-input type="text" v-model="tel" id="tel" placeholder="手机号或邮箱登录" style="margin-bottom: 0.6vw" />
              <div v-if="emlog" style="display: flex">
                <el-input type="text" v-model="code" id="code" placeholder="验证码" style="margin-bottom: 0.2vw">
                  <div slot="append" @click="getcodebtn" style="cursor: pointer; color: #4f36de">
                    获取验证码
                  </div>
                </el-input>
              </div>

              <el-input type="password" v-model="pwd" id="pwd" placeholder="请输入密码" style="margin-bottom: 0.2vw"
                v-else />
              <div style="
                  cursor: pointer;
                  display: flex;
                  justify-content: space-between;
                ">
                <div></div>
                <div @click.stop="sellogin">
                  {{ sellog }}
                </div>
              </div>
            </div>
            <el-button type="primary" style="
                width: 100%;
                height: 1.8vw;
                background: linear-gradient(to right, #792ee7, #04c0cd);

                margin-top: 1vw;
              " @click.stop="tologin">
              登录
            </el-button>
            <div style="text-align: center; cursor: pointer" @click.stop="(regstatus = true), (loginstatus = false)">
              新用户注册
            </div>
          </div>

          <div style="width: 100%" v-if="regstatus">
            <div>
              <el-input type="text" v-model="tel" id="tel" placeholder="手机号或邮箱注册" style="margin-bottom: 0.2vw" />

              <el-input type="password" v-model="pwd" id="pwd" placeholder="请输入密码" style="margin-bottom: 0.2vw" />
              <el-input type="password" v-model="conpwd" id="conpwd" placeholder="请确认密码" style="margin-bottom: 0.2vw" />
              <div style="display: flex">
                <el-input type="text" v-model="code" id="code" placeholder="验证码">
                  <div slot="append" @click="getcodebtn" style="cursor: pointer; color: #6854e3">
                    获取验证码
                  </div>
                </el-input>
              </div>
            </div>
            <el-button type="primary" style="
                width: 100%;
                height: 1.8vw;
                background: linear-gradient(to right, #792ee7, #04c0cd);

                margin-top: 0.6vw;
              " @click.stop="toreg">
              注册
            </el-button>
            <div style="text-align: center; cursor: pointer" @click.stop="(loginstatus = true), (regstatus = false)">
              立即登录
            </div>
          </div>
          <div style="text-align: center; margin-top: 1.6vw">
            <el-radio v-model="applyLicence" label="1">
              <span style="color: #000">阅读并同意</span>
              <a @click="showxieyi=true" style="color: #4f36de">《用户协议》</a>
              <span style="color: #000">和</span>
              <a @click="showyinsi=true" style="color: #4f36de">《隐私政策》</a>
            </el-radio>
          </div>
          <el-dialog title="" append-to-body :visible.sync="showxieyi" width="30%" :show-close="false">
            <div style="max-height: 30vw; overflow-y: scroll">
              <h2 style="text-align: center">全球能用户服务协议</h2>
              <p>更新日期：2025年4月18日</p>
              <p>生效日期：2025年4月25日</p>
              <p>一、特别提示</p>
              <p>
                1.1
                欢迎您登录全球能平台（以下简称"本平台"）使用全球能软件及相关服务（以下简称"全球能服务"）。本平台的运营者及全球能服务的提供者均为新能在线（上海）科技有限公司。各条款标题仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您的自身权益，建议您仔细阅读各条款具体表述。
              </p>
              <p>
                1.2
                《全球能隐私政策》以及本平台公布的其他协议规范、规则、声明、公告、政策等（以下统称"其他全球能规则"）是本协议不可分割的组成部分，您在使用全球能服务时应同样遵守。您接受并同意本协议的行为即视为您同意并接受其他全球能规则，您接受并同意任一其他全球能规则的行为亦视为您接受并同意本协议。
              </p>
              <p>
                1.3
                您在申请注册流程中或在本协议更新时点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款，您应重点阅读。
              </p>
              <p>
                1.4
                当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后或在本协议更新时点击同意，即表示您已充分阅读、理解并接受本协议的全部内容。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您将无法正常使用全球能服务并影响您使用全球能服务的部分功能。
              </p>
              <p>二、服务内容</p>
              <p>
                2.1
                全球能服务的具体内容由本平台根据实际情况提供，包括但不限于授权您通过其账号，使用全球能服务发布的内容、评论，浏览相关资讯，参与互动交流等。本平台有权对全球能服务或产品形态进行升级或其他调整，并将及时更新页面/告知。
              </p>
              <p>
                2.2
                您理解，本平台仅提供与全球能服务相关的技术服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由您自行负担。
              </p>
              <p>三、服务变更、中断或终止</p>
              <p>
                3.1
                鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他本平台无法控制的情形），用户同意本平台有权随时中断或终止部分或全部的全球能服务，若发生该等中断或中止全球能服务的情形，本平台将尽可能及时通过网页公告、系统通知、私信、短信提醒或其他合理方式通知受到影响的用户。
              </p>
              <p>
                3.2
                您理解，本平台需要定期或不定期地对提供全球能服务的平台（如互联网网站、移动网络、客户端软件等）或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，本平台无需为此承担任何责任，但本平台应尽可能事先进行通告。
              </p>
              <p>
                3.3
                如发生下列任何一种情形，本平台可能随时中断或终止向您提供本协议项下的全球能服务：
              </p>
              <p>1. 您提供的个人资料不真实；</p>
              <p>
                2.
                您违反法律法规、国家政策或本协议及本平台公示的各项规则、规范。
              </p>
              <p>
                3.4
                如您在申请开通全球能服务后在任何连续180日内未实际使用，则本平台有权选择采取以下任何一种方式进行处理：
              </p>
              <p>1. 回收并注销您的昵称、账号；</p>
              <p>2. 停止为您提供全球能服务。</p>
              <p>
                3.5
                若您选择将全球能账号与本平台合作的第三方账号进行绑定的，除您自行解除绑定关系外，发生下列任何一种情形，您已绑定的第三方账号也有可能被解除绑定而本平台无需对您或任何第三方承担任何责任：
              </p>
              <p>1. 您违反法律法规国家政策或本协议的；</p>
              <p>2. 您违反第三方账号服务商的用户协议或其相关规定的；</p>
              <p>3. 发生其他本平台认为需要解除绑定的情形。</p>
              <p>四、使用规则</p>
              <p>
                4.1
                注册全球能账号制作、发布、传播信息内容的，应当使用真实身份信息及个人资料，不得以虚假、冒用的居民身份信息、企业注册信息、组织机构代码信息进行注册；若用户的个人资料有任何变动，用户应及时更新。
              </p>
              <p>
                4.2
                您可自行编辑注册信息中的账号名称、头像、简介等，但应遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等"七条底线"以及相关管理规定，不得含有违法和不良信息。
              </p>
              <p>
                4.3
                如您违反前述约定，依据相关法律、法规及国家政策要求，本平台有权随时采取不予注册、通知限期改正、注销登记用户账号、中止或终止用户对全球能服务的使用等措施。如您冒用其他自然人或组织的姓名或名称注册账号，本平台有权注销该用户账号，并向互联网信息内容主管部门报告。
              </p>
              <p>
                4.4
                本平台将建立健全用户信息安全管理制度、落实技术安全防控措施。本平台将对用户使用全球能服务过程中涉及的用户隐私内容加以保护。
              </p>
              <p>
                4.5
                由于全球能服务的存在前提是您在申请开通全球能服务的过程中所提供的账号，因此您不应将账号、密码转让或出借予他人使用。如您发现账号或全球能服务遭他人非法使用，应立即通知本平台。因黑客行为或用户的保管疏忽导致账号、密码及全球能服务遭他人非法使用，本平台不对非因本平台原因造成的损失承担责任。
              </p>
              <p>
                4.6
                您在使用全球能服务的过程中应文明发言，并依法尊重其它用户的人格权与身份权等人身权利，共同建立和谐、文明、礼貌的网络社交环境。
              </p>
              <p>4.7 您在使用全球能服务过程中，必须遵循以下原则：</p>
              <p>1. 不得违反中华人民共和国法律法规及相关国际条约或规则；</p>
              <p>
                2.
                不得违反与网络服务、全球能服务有关的网络协议、规定、程序及行业规则；
              </p>
              <p>
                3.
                不得违反法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等"七条底线"要求；
              </p>
              <p>
                4. 不得进行任何可能对互联网或移动网正常运转造成不利影响的行为；
              </p>
              <p>
                5.
                不得上传、展示或传播任何不实的、虚假的、冒充性的、骚扰性的、中伤性的、攻击性的、辱骂性的、恐吓性的、种族歧视性的、诽谤诋毁的、泄露隐私的、涉及成人情色的、恶意抄袭的或其他任何非法的信息资料；
              </p>
              <p>6. 不得发布破坏国家宗教政策，宣扬邪教和封建迷信等内容；</p>
              <p>
                7.
                不得以任何方式侵犯其他任何人依法享有的专利权、著作权、商标权等知识产权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等人身权益，或其他任何合法权益；
              </p>
              <p>
                8.
                不得以任何形式侵犯本平台的权利和/或利益或作出任何不利于本平台的行为；
              </p>
              <p>
                9.
                不得从事其他任何影响本平台正常运营、破坏本平台经营模式或其他有害本平台生态的行为；
              </p>
              <p>
                10.
                不得上传、展示或传播任何含有历史虚无主义的信息内容，包括但不限于：
                i) 歪曲党史、新中国史、改革开放史、社会主义发展史； ii)
                诋毁、污蔑、丑化党和国家领导人； iii)
                贬损、丑化革命烈士，亵渎、否定英雄事迹和精神； iv)
                否定中华民族文明史和中华优秀传统文化； v)
                其他含有或构成历史虚无主义信息内容；
              </p>
              <p>11. 不得为其他任何非法目的而使用全球能服务。</p>
              <p>
                4.8
                如您在使用全球能服务的过程中遇到其它用户上传违法侵权等内容，可通过"设置"-"帮助与反馈"联系本平台进行投诉反馈，本平台会尽快核实并按照相应法律法规进行处理；如您认为上述方法无法解决遇到的问题，或您觉得有必要向司法行政机关寻求帮助的，本平台将依法配合司法机关的调查取证工作。
              </p>
              <p>
                4.9
                您知悉、理解并同意授权本平台可非独家、可转授权地使用您通过使用全球能服务发布的内容，前述内容包括但不限于文字、图片、视频等。具体来说，可能会包括：
              </p>
              <p>
                1.
                将前述内容通过本平台自身或其他第三方在本平台选择的网络平台、应用程序或产品中，以有线或无线网，通过免费或收费的方式在不同终端（包括但不限于电脑、手机、互联网电视、机顶盒及其他上网设备等）以不同形式进行网络传播或电信增值服务等；
              </p>
              <p>
                2.
                将前述内容复制、翻译、编入本平台当前已知或以后开发的作品、媒体或技术中，用于提供全球能服务相关的开发或推广宣传工作等；
              </p>
              <p>
                3.
                将前述内容授权给电台、电视台、网络媒体、运营商平台等与本平台有合作的媒体或运营商播放、传播，用于全球能平台相关的推广宣传等；
              </p>
              <p>4. 其他本平台出于善意或另行取得用户授权的使用行为；</p>
              <p>
                5.
                用户对本平台的前述授权并不改变用户发布内容的所有权及知识产权归属，也并不影响用户行使其对发布内容的合法权利；
              </p>
              <p>
                6.
                本平台将尽最大的商业努力合理使用用户的授权内容，但并不代表本平台承诺一定会使用。
              </p>
              <p>
                4.10
                本平台有权对您使用全球能服务的行为及信息进行审查、监督及处理，包括但不限于用户信息（账号信息、个人信息等）、发布内容（位置、文字、图片、音频、视频、商标、专利、出版物等）、用户行为（构建关系、@信息、评论、私信、参与话题、参与活动、营销信息发布、举报投诉等）等范畴。如本平台发现、或收到第三方向本平台举报或投诉您在使用全球能服务时违反本协议第4条使用规则相关规定，本平台或其授权的主体有权依据其合理判断要求用户：
              </p>
              <p>1. 限期改正；</p>
              <p>
                2.
                不经通知直接采取一切必要措施以减轻或消除用户不当行为造成的影响，并将尽可能在处理之后对用户进行通知。上述必要措施包括但不限于更改、屏蔽或删除相关内容，警告违规账号，限制或禁止违规账号部分或全部功能，暂停、终止、注销用户使用全球能服务的权利等。
              </p>
              <p>五、广告</p>
              <p>
                5.1
                您理解并同意，在使用全球能服务过程中本平台可能会向您推送具有相关性的信息、广告发布或品牌推广服务，或在本平台展示全球能相关和/或第三方供应商、合作伙伴的商业广告、推广或信息（包括商业或非商业信息）。
              </p>
              <p>
                5.2
                在使用全球能服务过程中，本平台可能会通过电子邮件或其他方式向您发送的商品促销或其他相关商业信息，您可以选择退订我们发送给您的营销信息。
              </p>
              <p>
                5.3
                本平台依照法律规定履行广告及推广相关义务，您应当自行判断该广告或推广信息的真实性和可靠性并为自己的判断行为负责。除法律法规明确规定外，您因该广告或推广信息进行的购买、交易或因前述内容遭受的损害或损失将由您自行承担，非因本平台原因造成的损失本平台不予承担责任。
              </p>
              <p>六、知识产权</p>
              <p>
                6.1
                在本平台及全球能服务中所提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于本平台或原始著作权人所有。本平台提供全球能服务时所依托的软件的著作权、专利权及其他知识产权均归本平台所有。未经本平台许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）全球能服务中的内容。
              </p>
              <p>
                6.2
                您理解并同意，在使用全球能服务时发布上传的文字、图片、视频、音频等均由您原创或已获得合法授权。您通过本平台上传、发布的任何内容的知识产权归属您或原始著作权人所有。
              </p>
              <p>
                6.3
                您在使用全球能服务的过程中，可能会使用到由第三方针对全球能服务开发的在全球能平台运行的软件或提供的服务，您除遵守本协议相关规定以外，还应遵守该等第三方的相关规定，并尊重第三方权利人对其软件、服务及其所包含内容的相关权利。
              </p>
              <p>6.4 鉴于以上，您理解并同意：</p>
              <p>
                1.
                未经本平台及相关权利人同意，您不得对上述功能、软件、服务进行反向工程（reverse
                engineer）、反向编译（decompile）或反汇编（disassemble）等；同时，不得将上述内容或资料在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者用于其他任何目的；
              </p>
              <p>
                2.
                本平台为全球能服务开发、运营功能及相关软件、服务的知识产权均由本平台所有。除非本平台书面同意，您不得修改、出售、展示、使用、传播前述任何功能、软件及服务的任何副本，也不得对前述任何功能、软件及服务的任何部分或全部进行反向工程，或以其他方式尝试从中获取源代码；
              </p>
              <p>
                3.
                经本平台书面同意使用前述内容、功能、软件或服务的，您须在授权的时间内、范围内进行使用，并且不得对本平台及权利人的知识产权以及相关权利进行任何形式的损害、冒犯或贬损；
              </p>
              <p>
                4.
                您须尊重著作权人及其他第三方的知识产权。如您违反前述规定侵害第三方权利的，您还应当直接向权利人或权利人指定的第三方承担责任。
              </p>
              <p>x七、免责声明</p>
              <p>
                7.1
                本平台仅为用户提供信息分享、传播及获取的平台，对于本平台服务中的用户提供的信息/内容，本平台将尽合理范围内的注意义务，但不对其内容的真实性、准确性、合法性或适当性作出保证。用户需自行判断内容的真实性、准确性和完整性。
              </p>
              <p>
                7.2
                由于网络传输存在一定风险，本平台并不能保证全球能服务完全适合用户的需求，也不保证全球能服务不会受中断，对服务的及时性、安全性、准确性也无法作出保证。对于由此给用户造成的损失，本平台不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。
              </p>
              <p>
                7.3
                对于因电信系统或互联网网络故障、计算机故障或病毒、信息损坏或丢失、计算机系统问题或其他任何不可抗力原因而产生损失，本平台不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
              </p>
              <p>
                7.4
                本协议条款的拟定、解释及争议的解决均适用中华人民共和国大陆地区法律。因本协议引起的或与本协议有关的任何争议，各方应友好协商解决；协商不成的，任何一方均应将争议提交北京市海淀区人民法院管辖。
              </p>
              <p>八、协议变更</p>
              <p>
                8.1
                本平台有权在必要时修改本协议条款，并将修改后的版本通过网页公告、系统通知、私信、短信提醒或其他合理方式通知您，请您收到通知后及时查阅修改的内容。
              </p>
              <p>
                8.2
                如您不同意相关变更，您有权停止使用全球能服务。如您继续使用全球能服务，则视为您已阅读、理解并接受经修订的协议。
              </p>
              <p>
                8.3
                本协议条款变更后，如果您继续使用全球能服务，即视为您接受修改后的协议。如您不接受修改后的协议，应立即停止使用全球能服务。
              </p>
              <p>九、其他规定</p>
              <p>
                9.1 本协议中的标题仅为方便阅读而设，不影响对本协议内容的解释。
              </p>
              <p>
                9.2
                本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
              </p>
              <p>
                9.3
                本协议的版权为新能在线（上海）科技有限公司所有，并保留对本协议的最终解释权。
              </p>
              <p>
                9.4
                若您对本协议内容有任何疑问，可通过官方网站底部的"联系我们"进行咨询。
              </p>
              <p>新能在线（上海）科技有限公司</p>
            </div>
            <span slot="footer" class="dialog-footer" style="text-align: right">
              <el-button type="primary" @click="showxieyi = false" style="background: linear-gradient(to right, rgb(121, 46, 231), rgb(4, 192, 205)); ">
                同意并继续
              </el-button>
            </span>
          </el-dialog>
          <el-dialog title="" append-to-body :visible.sync="showyinsi" width="30%" :show-close="false">
            <div style="max-height: 30vw; overflow-y: scroll">
              <h2 style="text-align: center">全球能服务隐私政策</h2>
              <p>更新日期：2025年4月18日</p>
              <p>生效日期：2025年4月25日</p>
              <p>一、政策概述与适用范围</p>
              <p>
                尊敬的用户，欢迎您使用全球能服务。新能在线（上海）科技有限公司（以下简称"我们"）重视您的个人信息和隐私保护。本隐私政策旨在向您说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您享有的相关权利。
              </p>
              <p>
                本隐私政策适用于我们通过网站、移动应用程序、小程序以及其他形式向您提供的全球能服务。如果您使用全球能服务，即表示您认可并接受本隐私政策的全部内容。请您在使用我们的服务前，仔细阅读并确认您已完全理解本政策的内容。
              </p>
              <p>二、信息收集与使用</p>
              <p>2.1 信息收集的原则</p>
              <p>
                我们严格遵循合法、正当、必要的原则收集和使用您的个人信息。我们仅会收集实现产品功能所必要的信息，且会事先获得您的同意。
              </p>
              <p>2.2 我们收集的信息</p>
              <p>根据服务的不同需求，我们可能收集以下类型的信息：</p>
              <p>2.2.1 您主动提供的信息</p>
              <p>
                •
                账号信息：当您注册全球能服务账号时，我们需要收集您的手机号码或电子邮箱地址，以及您设置的用户名和密码。
              </p>
              <p>
                •
                个人资料：您可以选择提供昵称、头像、性别、出生日期、职业等信息来完善您的个人资料。
              </p>
              <p>• 认证信息：特定功能（如直播）可能需要您提供实名认证信息。</p>
              <p>2.2.2 在您使用服务过程中收集的信息</p>
              <p>• 设备信息：设备型号、操作系统、唯一设备标识符、IP地址等。</p>
              <p>
                •
                日志信息：您使用我们服务的详细情况，如搜索查询内容、访问日期和时间等。
              </p>
              <p>
                •
                位置信息：经您授权，我们可能会收集您的大致位置信息，以便为您提供位置相关服务。
              </p>
              <p>2.3 信息的使用</p>
              <p>我们可能将收集的信息用于以下用途：</p>
              <p>• 向您提供所请求的产品和服务</p>
              <p>• 验证您的身份，防止欺诈</p>
              <p>• 改进和优化我们的产品和服务</p>
              <p>• 推送通知或服务相关公告</p>
              <p>• 客户服务与问题解决</p>
              <p>• 遵守法律法规的要求</p>
              <p>2.4 敏感个人信息的保护</p>
              <p>
                本隐私政策中的敏感个人信息指一旦泄露或非法使用，可能导致个人受到歧视或人身、财产安全受到严重威胁的信息，包括身份证号码、银行账号、通信记录和内容、财产信息、生物识别信息等。我们会对敏感个人信息采取额外的保护措施，并且只在必要的情况下收集和使用此类信息。
              </p>
              <p>三、Cookie和类似技术的使用</p>
              <p>3.1 Cookie的使用</p>
              <p>
                我们使用Cookie和类似技术来提供、保护和改进我们的产品和服务。Cookie是存储在您设备上的小数据文件，能够帮助网站记住您的登录状态、偏好设置等信息。
              </p>
              <p>3.2 您的选择</p>
              <p>
                您可以通过浏览器设置接受或拒绝Cookie。但请注意，如果您选择拒绝Cookie，您可能无法使用依赖于Cookie的全球能服务的某些功能。
              </p>
              <p>四、信息共享、转让和公开披露</p>
              <p>4.1 信息共享</p>
              <p>我们不会向第三方共享您的个人信息，但以下情况除外：</p>
              <p>• 在获得您明确同意的情况下</p>
              <p>• 与我们的关联公司共享，用于为您提供服务或进行业务支持</p>
              <p>
                • 与授权合作伙伴共享，以提供特定服务（如支付处理、技术支持等）
              </p>
              <p>• 根据法律法规的规定、法院命令或政府机构的要求</p>
              <p>4.2 信息转让</p>
              <p>
                在业务转让、合并、收购或破产清算等情况下，如涉及个人信息转让，我们会要求新的持有您个人信息的公司或组织继续受本隐私政策约束，否则我们会要求该公司或组织重新获取您的授权同意。
              </p>
              <p>4.3 公开披露</p>
              <p>
                除非获得您的明确授权或法律法规要求，否则我们不会公开披露您的个人信息。
              </p>
              <p>五、信息存储与安全保护</p>
              <p>5.1 信息存储</p>
              <p>
                我们会按照法律法规规定，将在中国境内收集的个人信息存储在中国境内。目前，我们不会将上述信息传输至境外。如需跨境传输，我们会单独征得您的授权同意，并确保数据接收方有同等的数据保护水平。
              </p>
              <p>5.2 信息安全</p>
              <p>我们采取业界标准的安全措施保护您的个人信息，包括但不限于：</p>
              <p>• 使用加密技术确保数据的保密性</p>
              <p>• 建立数据分类分级制度、数据安全管理规范、数据安全开发规范</p>
              <p>• 加强员工数据安全培训和意识教育</p>
              <p>• 定期进行安全评估和风险识别</p>
              <p>5.3 安全事件处理</p>
              <p>
                尽管我们竭尽全力保护您的信息安全，但由于技术的限制和可能存在的各种恶意手段，我们无法始终保证信息的绝对安全。如发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知事件基本情况、可能的影响、已采取或将要采取的处置措施、您可自主防范和降低风险的建议等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。
              </p>
              <p>六、您的权利</p>
              <p>您对个人信息拥有以下权利：</p>
              <p>6.1 访问和更正权</p>
              <p>
                您有权访问和更正您的个人信息。您可以通过"个人中心"→"编辑信息"功能查看和修改您的账号信息。
              </p>
              <p>6.2 删除权</p>
              <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
              <p>• 处理目的已实现、无法实现或不再需要实现</p>
              <p>• 我们停止提供产品或服务，或保存期限已届满</p>
              <p>• 您撤回同意</p>
              <p>• 我们违反法律法规或与您的约定处理个人信息</p>
              <p>6.3 撤回同意权</p>
              <p>
                您可以通过注销账号、关闭设备功能等方式变更或撤回您的授权同意范围。请注意，您撤回同意的决定不会影响我们此前基于您的授权而开展的个人信息处理活动的有效性。
              </p>
              <p>6.4 注销权</p>
              <p>
                您可以通过"我的"→"设置"→"账号注销"申请注销账号。注销账号后，我们将停止为您提供服务，并根据适用法律的要求删除或匿名化处理您的个人信息。
              </p>
              <p>七、未成年人保护</p>
              <p>
                我们非常重视未成年人个人信息的保护。若您是未成年人，应在监护人指导下阅读本隐私政策，并在监护人同意的前提下使用我们的服务和提供个人信息。对于经监护人同意而收集的未成年人个人信息，我们仅会在法律允许、监护人明确同意或保护未成年人所必要的情况下使用或公开披露。
              </p>
              <p>八、政策更新</p>
              <p>
                我们可能会不时更新本隐私政策。当本隐私政策发生重大变更时，我们会在应用程序或网站显著位置发布变更通知。在此情况下，若您继续使用我们的服务，即表示您同意受经修订的隐私政策的约束。重大变更包括但不限于：
              </p>
              <p>• 我们的服务模式发生重大变化</p>
              <p>• 个人信息的处理目的、处理方式、处理的个人信息类型发生变化</p>
              <p>• 您参与个人信息处理方面的权利及其行使方式发生重大变化</p>
              <p>• 我们的联系方式及投诉渠道发生变化</p>
              <p>九、联系我们</p>
              <p>
                如您对本隐私政策有任何疑问、意见或建议，或您认为我们的个人信息处理行为违反法律法规或本隐私政策的约定，您可以通过以下方式与我们联系：
              </p>
              <p>• 官方网站："联系我们"页面</p>
              <p>我们将在收到您的问题后15个工作日内予以回复。</p>
              <p>十、争议解决</p>
              <p>
                本隐私政策的解释及争议解决均适用中华人民共和国法律。若您与我们之间发生任何争议，我们希望通过友好协商的方式解决。协商不成的，您同意将争议提交至北京市海淀区人民法院进行诉讼解决。
              </p>
            </div>
            <span slot="footer" class="dialog-footer" style="text-align: right">
              <el-button type="primary" @click="showyinsi = false" style="background: linear-gradient(to right, rgb(121, 46, 231), rgb(4, 192, 205)); ">
                同意并继续
              </el-button>
            </span>
          </el-dialog>
          <el-dialog title="" append-to-body :visible.sync="getcode" width="30%">
            <el-input type="text" v-model="captcha" id="captcha" placeholder="验证码" style="margin-bottom: 0.2vw">
              <div slot="append" @click="refreshcode" style="cursor: pointer">
                <img :src="codeimg" alt="" style="width: 4vw" />
              </div>
            </el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="getcode = false">取 消</el-button>
              <el-button type="primary" @click="getcodemsg">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
      <div style="
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
        <div v-if="ewmstu" class="card" style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
          ">
          <div v-if="!ewmlog" style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-top: -1vw;
            ">
            <div style="
                color: #000;
                width: 100%;
                text-align: center;
                font-size: 1vw;
                font-weight: 600;
              ">
              扫码登录
            </div>
            <div style="width: 100%; text-align: center; margin-bottom: 1vw">
              请使用微信扫描二维码登录
            </div>
            <!-- <el-image lazy :src="loginyzm" style="
                width: 10vw;
                height: 10vw;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
              ">
              <div slot="error" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image> -->
            <div style="position:relative;">
                <el-image lazy :src="loginyzm" style="
                width: 10vw;
                height: 10vw;
                margin-bottom: 2vw;
                display: flex;
                justify-content: center;
                align-items: center;
            ">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-loading"></i>
                    </div>
                    
                </el-image>
                <div class="el-loading-mask" v-if="expire" style="z-index:999;width: 10vw;height: 10vw;display: flex; flex-direction: column;align-items:center;">
                    <p style="margin:50px 0 0 0;color:#333;font-weight:bold;">小程序码已过期</p>
                    <el-button @click="reloadEr" style="margin-top:20px;">刷 新</el-button>
                </div>
                <div class="el-loading-mask" v-if="ewmlog" style="z-index:999;width: 10vw;height: 10vw;display: flex; flex-direction: column;align-items:center;">
                    <!-- <i class="el-icon-check" style="font-size:50px;color:#4273DB;margin:60px 0 0 0;"></i> -->
                    <img src="@/assets/ysm.png" alt="" style="width: 4vw; height: 4vw;margin-top:30px;"/>
                    <p style="margin:10px 0 0 0;color:#333;font-weight:bold;">已扫码</p>
                    <p style="margin:5px 0 0 0;color:#333;font-weight:bold;">请在手机上确认登录</p>
                </div>
            </div>

            <!-- <el-button @click="cancelsm">取 消</el-button> -->
          </div>

          <img src="@/assets/ysm.png" alt="" style="width: 8vw; height: 8vw" v-else />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  GetCode,
  ToReg,
  ToLogin,
  GetCodeImg,
  GetEr,
  IfEr,
} from "@/api/user.js";
// let settoken = null;

export default {
  props: ["showDalog"],
  data() {
    return {
      showyinsi: false,
      showxieyi: false,
      applyLicence: "",
      // showDalog:false,
      dialogVisible: false,
      tel: "",
      pwd: "",
      conpwd: "",
      loginstatus: true,
      regstatus: false,
      emlog: false,
      sellog: "验证码登录",
      getcode: false,
      codeimg: "",
      captcha: "",
      code: "",
      loginyzm: "",
      ewmstu: true,
      key: "",
      lid: "",
      ewmlog: false,
      dialogVisiblemob: false,
      dialogVisiblevip: false,
      dialogVisibleCard: false,
      cardinfo_v1: [],
      levelinfo: [],
      cardinfo_v2: [],
      settoken: null,
      expire:false,
    };
  },
  computed: {
    isToken() {
      if (localStorage.getItem("token") && localStorage.getItem("token") != 'undefined' && localStorage.getItem("token").trim() != '') {
          return true
      } else {
          false
      }
    },
  },
  watch: {
    showDalog(newVal, oldVal) {
      if (newVal == true) {
        this.ewm();
      }
    },
  },
  created() {
    console.log("showDalog", this.showDalog);
    // this.ewm();
  },
  mounted() {
    window.addEventListener("beforeunload", this.closeDialog);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.closeDialog);
  },
  methods: {
    closeDialog() {
      this.$emit("sendData", "closepop"); // 关登录
      if (this.settoken) {
        clearInterval(this.settoken);
      }

      console.log("closeDialog");
    },
    getcodebtn() {
      this.getcode = true;
      const t = Date.now();
      GetCodeImg({ time: t }).then((response) => {
        this.codeimg = URL.createObjectURL(response);
      });
      // this.codeimg = `https://demo.yinaixinxi.com/?s=/v1.pc.user/verify&aid=1&t=${t}`;
    },
    refreshcode() {
      const t = Date.now();
      GetCodeImg({ time: t }).then((response) => {
        this.codeimg = URL.createObjectURL(response);
      });
      // this.codeimg = `https://demo.yinaixinxi.com/?s=/v1.pc.user/verify&aid=1&t=${t}`;
    },
    getcodemsg() {
      GetCode({ account: this.tel, code: this.captcha }).then((res) => {
          console.log("获取验证码", res);
          if (res.code != 200) {
              this.refreshcode();
              this.$message.error(res.msg);
          } else {
              this.$message(res.msg);
              this.getcode = false;
          }
      });
      console.log(this.captcha);
    },

    cancelsm() {
      clearInterval(this.settoken );
      this.ewmstu = false;
    },
    reloadEr(){
      this.expire = false;
      if(this.settoken){
          clearInterval(this.settoken );
      }
      this.ewm();
    },
    ewm() {
      this.ewmstu = true;
      GetEr().then((res) => {
          console.log("二维码", res);
          this.loginyzm = `data:image/png;base64,${res.data.qrCodeUrl}`;
          console.log(this.loginyzm);
          this.sceneStr = res.data.sceneStr;
          // this.lid = res.data.lid;
          // this.key = res.data.key;
          // IfEr({ key: key }).then((res) => {
          //   console.log(res);
          // });
          if (res.code == 200) {
              this.settoken  = setInterval(() => {
                  this.pcloginstu();
              }, 1000);
          }
      });
    },
    pcloginstu() {
      IfEr({ sceneStr: this.sceneStr }).then((res) => {
        console.log("扫码登录", res);
        if(res.code==200){   //登录成功
            if (this.settoken ) {
                clearInterval(this.settoken );
            }
            this.$message.success(res.msg);
            this.ewmstu = false;
            localStorage.setItem("token", res.data.token);
            setTimeout(window.location.reload(), 1500);
        }else if(res.code==400){    // 已过期
            this.expire = true;  
            if(this.settoken){
                clearInterval(this.settoken );
            }
        }else if(res.code==201&&res.data.status=='waiting'){    // 等待扫码
            
        }else if(res.code==201&&res.data.status=='scanned'){    // 已扫码等待确认
            this.ewmlog = true;
        }else if(res.code==202){    // 取消授权
            this.$message.error(res.msg);
            if (this.settoken ) {
                clearInterval(this.settoken );
            }
            this.ewmlog = false;
            this.ewmstu = false;
        }else{
            this.$message.error(res.msg);
            if (this.settoken ) {
                clearInterval(this.settoken );
            }
            this.ewmlog = false;
            this.ewmstu = false;
        }
      })
    },
    loginbtn() {
      this.loginstatus = true;
    },
    regbtn() {
      this.regstatus = true;
    },
    tologin() {
      if (this.applyLicence != "1") {
        this.$message.error("请勾选阅读并同意《用户协议》和《隐私政策》");
        return;
      }
      // ToLogin({ account: this.tel, password: this.pwd, code: this.code }).then(
      //   (res) => {
      //     console.log("登录", res);
      //     console.log("登录", res);
      //     if (res.code == 200) {
      //         this.$message.success(res.msg);
      //         this.ewmstu = false;
      //         localStorage.setItem("token", res.data);
      //         window.location.reload();
      //     } else {
      //         this.$message.error(res.msg);
      //     }
      //   }
      // );
      //emlog为false时密码登录
      let param = {};
      if (!this.emlog) {
          param = { account: this.tel, password: this.pwd }
          if (!this.pwd) {
              this.$message.error('请输入密码');
              return
          }
      }
      if (this.emlog) {
          param = { account: this.tel, code: this.code };
          if (!this.code) {
              this.$message.error('请输入验证码');
              return
          }
      }
      ToLogin(param).then(
          (res) => {
              console.log("登录", res);
              if (res.code == 200) {
                  this.$message.success(res.msg);
                  this.ewmstu = false;
                  localStorage.setItem("token", res.data);
                  window.location.reload();
              } else {
                  this.$message.error(res.msg);
              }
          }
      );
    },
    toreg() {
      ToReg({
        account: this.tel,
        code: this.code,
        password: this.pwd,
        confirm_password: this.conpwd,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.code = "";
          (this.loginstatus = true), (this.regstatus = false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    sellogin() {
      if (this.emlog) {
        (this.emlog = false), (this.sellog = "验证码登录");
      } else {
        (this.emlog = true), (this.sellog = "密码登录");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 70px 0 40px 0;
  background: #e8eef2;

  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;

    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;

    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }

  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    height: 700px;
    border-radius: 8px;

    @media screen and (max-width: 768px) {
      width: 95%;
    }

    ::v-deep .el-carousel {
      height: 100%;

      .el-carousel__container {
        height: 100%;
      }
    }

    .card {
      height: 70%;
      background: linear-gradient(to top left, #9cc0f8, #ffffff);
      display: flex;
      flex-direction: column;
      align-items: center;

      .cardInfo {
        padding: 1vw;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom right, #ffffff, #94c0fe);
        display: flex;
        flex-direction: column;
        align-items: center;

        .cardTop {
          display: flex;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
        }

        .cardBody {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;

          .fabu {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
          }
        }

        .vipbtn {
          margin-bottom: 0.5vw;
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          background: linear-gradient(to top, #1e037c, #2520ab);
          padding: 0.5vw;
          cursor: pointer;
          border-top-right-radius: 0.3vw;
          border-top-left-radius: 0.3vw;
        }

        .cardBottom {
          margin-bottom: 1vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;

          .cardlist {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 30%;
            margin-bottom: 1vw;
          }
        }

        .loginout {
          width: 60%;
          height: 2vw;
          background-color: #f3f5f4;
          text-align: center;
          line-height: 2vw;
          font-size: 2ch;
          font-weight: 600;
          color: #b0b3b7;
          border-radius: 2%;
          cursor: pointer;
        }
      }
    }

    .top-left {
      height: 100%;
      width: 22%;
      background: linear-gradient(to right, #792ee7, #04c0cd);
      display: flex;
      flex-direction: column;
      border-radius: 6px;

      .top-left-title {
        width: 100%;
        height: 7%;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }

      .top-left-info {
        width: 100%;
        // flex: 1;
        height: 93%;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        // padding: 30px 20px;
        // overflow-y: scroll;
        // -ms-overflow-style: none; /* IE 和 Edge */
        // scrollbar-width: none; /* Firefox */
      }

      .scrollable-container::-webkit-scrollbar {
        // display: none; /* 隐藏滚动条 */
      }
    }

    .top-center {
      height: 100%;
      width: 54%;
      // background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #e8eef2;
      }
    }

    .brain_item {
      transition: background-color 1s;
      padding: 30px;

      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;

        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }

      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;

      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(134deg,
            #0649b8 1%,
            #0a7fd7 41%,
            #03d2c5 99%);
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }

      &:hover .item_bg {
        opacity: 1;
      }

      &:hover .item_title {
        color: #fff;
      }

      &:hover .item_desc {
        color: #fff;
      }

      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;

        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }

      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;

        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }

      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;

        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
